<template>
  <div class="container">
    <HomeHeader />
    <MainPlayer :video="video" @update-liked="updateLikedStatus" v-if="video" />
    <AppFooter />
  </div>
</template>

<script>
// Import the CookieTimer component
import HomeHeader from "@/components/HomeHeader.vue";
import MainPlayer from "@/components/MainPlayer.vue";
import AppFooter from "@/components/AppFooter.vue";
import videoAPI from "@/api/videoAPI.js";

export default {
  components: {
    // Register the CookieTimer component
    HomeHeader,
    MainPlayer,
    AppFooter,
  },
  data() {
    return {
      // videoList: [],
      // videoId: ""
      // video: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    // Check if videoList exists in sessionStorage
    let storedList = sessionStorage.getItem("videoList");
    if (storedList) {
      next((vm) => {
        // Directly assign the storedList to the instance's videoList
        vm.videoList = JSON.parse(storedList);
      });
    } else {
      // Fetch the videoList if it doesn't exist in sessionStorage
      videoAPI.getVideos().then((videos) => {
        next((vm) => {
          vm.videoList = videos;
          sessionStorage.setItem("videoList", JSON.stringify(videos));
        });
      });
    }
  },
  computed: {
    videoList() {
      const storedList = sessionStorage.getItem("videoList");
      if (storedList) {
        return JSON.parse(storedList);
      } else {
        // You can't use async/await directly in computed,
        // so you might consider using a method or mounted hook for API calls
        return []; // or default value for videoList
      }
    },
    videoId() {
      return this.$route.params.id;
    },
    video() {
      return this.videoList.find((video) => video.id === this.videoId);
    },
  },
  async mounted() {
    if (!sessionStorage.getItem("videoList")) {
      const videos = await videoAPI.getVideos();
      sessionStorage.setItem("videoList", JSON.stringify(videos));
    }
  },
  methods: {
    updateLikedStatus(video) {
      const videoToUpdate = this.videoList.find((v) => v.id === video.id);
      if (videoToUpdate) {
        videoToUpdate.liked = video.liked;
        sessionStorage.setItem("videoList", JSON.stringify(this.videoList));
      }
    },
  },
};
</script>